module.exports = __webpack_public_path__ + "static/media/(000068).436b16b2.jpg";